// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"Rz","carousel__wrapper_on_sides":"Sz","arrows_wrapper":"Tz","arrows_wrapper_right":"Uz","arrows_wrapper_vertical":"Vz","arrows_wrapper_on_sides":"Wz","arrow_button":"Xz","carousel_arrow_left":"Yz","carousel_arrow_left_on_side":"Zz","carousel_arrow_right_on_side":"aA","carousel_arrow":"bA","arrows_wrapper_rounded":"cA","carousel__fullWidth":"eA"};
    if(module.hot) {
      // 1715188235910
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  